import { render } from "./ComoFunciona.vue?vue&type=template&id=3df8f526&scoped=true"
import script from "./ComoFunciona.vue?vue&type=script&lang=js"
export * from "./ComoFunciona.vue?vue&type=script&lang=js"

import "./ComoFunciona.vue?vue&type=style&index=0&id=3df8f526&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df8f526"]])

export default __exports__